import { type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError;

export type QueryKey = [EQueryKeys.MonolithPython__CianApi_Site_V1_GetUserDataByRequest];

export const getQueryKey = (): QueryKey => [EQueryKeys.MonolithPython__CianApi_Site_V1_GetUserDataByRequest];
